import { render, staticRenderFns } from "./FrenchWindowOtherDamages.vue?vue&type=template&id=251f982b&scoped=true"
import script from "./FrenchWindowOtherDamages.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f982b",
  null
  
)

export default component.exports